//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from '../title'
import Xfrom from '../from'
import Tab from '../from/tab'
import { InsurStore,InsurMutations } from '../../store'
import { CacheModule,setSessionParme } from '@/utils/commonUtils'


    export default {
        data() {
            return {
                defaultData:{},
                relationArr:['self', 'children','couple','parent' ],
                obj:{}
            }
        },
        components: {
            InTitle,
            Xfrom,
            Tab
        },
        props: {
            tabList:{
                type: Array,
                default: ()=>{
                    return []
                },
            },
            dataList: {
                type: Array,
                default: ()=>{
                    return []
                },
            }
        },
        computed: {
            last_identity() {
                return InsurStore.insurance.last_identity_info
            }
        },
        created(){

            this.obj = InsurMutations.getotherInfo(); 
            this.tabHandler(0)
        },
        methods: {
            tabHandler(index) {
                this.getOtherdeData(index)
                InsurMutations.setRelation(this.relationArr[index])
                this.$emit('tabClick',index)
            },
            check() {
                return this.$refs.MyFrom.check()
            },
            //获取被保人默认信息展示
            getOtherdeData(index){ 
                const relation = this.obj.relation //上次投保时被保人与本人的关系
                const data = this.obj.data
              if(this.relationArr[index] == relation && relation !='self'){ //当前被保人与上次投保的被保人关系一致时 展示上次被保人信息
                this.defaultData = data

              }else{
                this.defaultData = {}

              }
            },
            info(){
                return this.$refs.MyFrom.info()
            }
        },
    }
